import { useFormContext, UseFormReturn } from "react-hook-form";

interface Props {
    children: (methods: UseFormReturn) => any;
}

export const FormConsumser = ({ children = (methods: UseFormReturn) => {} }: Props) => {
    const methods = useFormContext();
    return children(methods) || null;
};

export default FormConsumser;
